<template>
  <div class="flex flex-col divide-y">
    <div v-for="i in randomInt()" :key="i" class="p-3">
      <div class="h-3 mb-2 animate-pulse">
        <div class="h-full bg-gray-200 rounded"></div>
      </div>
      <div class="h-10 mb-2 animate-pulse">
        <div class="h-full bg-gray-200 rounded"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { randomIntGenerator } from "@/helper";

export default {
  methods: {
    randomInt() {
      return randomIntGenerator(4, 1);
    },
  },
};
</script>
